// src/hooks/api/useErrors.js (Fixed filename from useErros.js)
import { useState, useCallback } from 'react';
import { errorsAPI } from '../services/errors';
import { useApi } from '../../../hooks/api/useApi';

export function useErrors() {
  const [errorSummary, setErrorSummary] = useState(null);
  const [errors, setErrors] = useState([]);
  const [errorDetails, setErrorDetails] = useState(null);
  const { loading, error, execute, clearError } = useApi();

  const fetchErrorSummary = useCallback(async (params = {}) => {
    const result = await execute(() => errorsAPI.getErrorSummary(params));
    if (result.success) {
      // useApi returns the full axios response, so result.data is the server response
      // Server response structure: { success, message, data: actual_summary_data }
      const serverResponse = result.data;
      const summaryData = serverResponse.data;
      console.log('Error Summary Data:', summaryData); // Debug log
      setErrorSummary(summaryData);
    }
    return result;
  }, [execute]);

  const fetchErrorsByEndpoint = useCallback(async (params) => {
    const result = await execute(() => errorsAPI.getErrorsByEndpoint(params));
    if (result.success) {
      // Server response structure: { success, message, data: array_of_errors }
      const serverResponse = result.data;
      const errorsData = serverResponse.data || [];
      console.log('Errors by Endpoint:', errorsData); // Debug log
      setErrors(Array.isArray(errorsData) ? errorsData : []);
    }
    return result;
  }, [execute]);

  const fetchErrorsByStaffMember = useCallback(async (staffMemberId, params = {}) => {
    const result = await execute(() => errorsAPI.getErrorsByStaffMember(staffMemberId, params));
    if (result.success) {
      const serverResponse = result.data;
      const errorsData = serverResponse.data || [];
      console.log('Errors by Staff Member:', errorsData); // Debug log
      setErrors(Array.isArray(errorsData) ? errorsData : []);
    }
    return result;
  }, [execute]);

  const fetchErrorsByDepartment = useCallback(async (departmentId, params = {}) => {
    const result = await execute(() => errorsAPI.getErrorsByDepartment(departmentId, params));
    if (result.success) {
      const serverResponse = result.data;
      const errorsData = serverResponse.data || [];
      console.log('Errors by Department:', errorsData); // Debug log
      setErrors(Array.isArray(errorsData) ? errorsData : []);
    }
    return result;
  }, [execute]);

  const fetchErrorDetails = useCallback(async (errorId) => {
    const result = await execute(() => errorsAPI.getErrorDetails(errorId));
    if (result.success) {
      const serverResponse = result.data;
      const detailsData = serverResponse.data;
      console.log('Error Details:', detailsData); // Debug log
      setErrorDetails(detailsData);
    }
    return result;
  }, [execute]);

  const cleanupOldErrors = useCallback(async (params = {}) => {
    const result = await execute(() => errorsAPI.cleanupOldErrors(params));
    // For cleanup, we can return the full result since it's used differently
    return result;
  }, [execute]);

  const countErrorsByEndpoint = useCallback(async (params) => {
    const result = await execute(() => errorsAPI.countErrorsByEndpoint(params));
    // For counting, we can return the full result since it's used differently
    return result;
  }, [execute]);

  const countErrorsByCode = useCallback(async (params) => {
    const result = await execute(() => errorsAPI.countErrorsByCode(params));
    // For counting, we can return the full result since it's used differently
    return result;
  }, [execute]);

  return {
    errorSummary,
    errors,
    errorDetails,
    loading,
    error,
    clearError,
    fetchErrorSummary,
    fetchErrorsByEndpoint,
    fetchErrorsByStaffMember,
    fetchErrorsByDepartment,
    fetchErrorDetails,
    cleanupOldErrors,
    countErrorsByEndpoint,
    countErrorsByCode,
  };
}